import React from 'react'
import './_header.scss'
var Header=()=>{
	var buttonContainer=<div className="button">
		<button>schedule a demo</button>
		<button>to see a preview</button>
	</div>

	return(
			<header>
				<img src="./images/illustration-devices.svg" alt="illustration-devices.svg"/>
				<section>
					<span><span className="new">New</span> monograph dashboard</span>
					<h1>Powerful insights into your team</h1>
					<p>Project planning and time tracking for agile
					teams</p>
					{buttonContainer}
				</section>
			</header>
		)
}

export default Header